import axios from "axios";
import { router } from "../router";

// const baseURL = "http://localhost:3000";
const baseURL = "https://orders.crophealthlabs.net";

const orderInterface = axios.create({
  baseURL,
});

orderInterface.interceptors.request.use(config => {
  config.headers.common["Authorization"] = localStorage.CHLToken;
  return config;
});

orderInterface.interceptors.response.use(async config => {
  if (!config.data.success && config.data.message === "authentication failed") {
    router.push("/loggedOut");
  }
  return config;
});

export const ChlBusiness = {
  create(business) {
    return orderInterface.post("/api/business", business);
  },
  getCurrent(userId) {
    return orderInterface.get(`/api/business/${userId}`);
  },
  search(name) {
    return orderInterface.get("/api/business", { params: { name } });
  },
  update(business) {
    return orderInterface.put("/api/business", business);
  },
};

export const ChlLocation = {
  create(location) {
    return orderInterface.post("/api/location", location);
  },
  getCurrent(businessId) {
    return orderInterface.get(`/api/location/${businessId}`);
  },
  update(location) {
    return orderInterface.put("/api/location", location);
  },
};

export const ChlPlot = {
  create(plot) {
    return orderInterface.post("/api/plot", plot);
  },
  getCurrent(locationId) {
    return orderInterface.get(`/api/plot/${locationId}`);
  },
  get(params) {
    return orderInterface.get("/api/plot", { params });
  },
  update(plot) {
    return orderInterface.put("/api/plot", plot);
  },
};

export const ChlOrder = {
  getCurrent(userId) {
    return orderInterface.get(`/api/NCCorder/${userId}`);
  },
  search(string) {
    return orderInterface.get(`/api/order/${string}`);
  },
  updateMeta(data) {
    return orderInterface.post("/api/orderMeta", data);
  },
  byId(id) {
    return orderInterface.get("/api/order", { params: { id } });
  },
  update(data) {
    return orderInterface.put("/api/order", data);
  },
  deleteLineItem(id) {
    return orderInterface.delete("/api/order/lineItem", { params: { id } });
  },

  updatePlantPart(records) {
    return orderInterface.post("/api/order/plantPart", { records });
  },
};

export const Chlcrop = {
  async get() {
    return await orderInterface.get("/api/crop");
  },
  async getVariety(cropId) {
    return await orderInterface.get(`/api/variety/${cropId}`);
  },
};
